import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import syncsOrganization from './organization'
import syncsChannels from './channels'
import subscriptions from './subscriptions'

import AppLoading from 'components/Layout/AppLoading'
import { ORGANIZATION_VIEW, CHANNELS_LIST } from 'components/viewNames'
import { getViewState } from 'data'

export function LoadingOrChildren({ isPristine, isLoading, children }) {
  if (isPristine || isLoading) {
    return <AppLoading />
  }
  return children
}

export const providesOrganizationSubscriptions = subscriptions

export default compose(
  syncsOrganization(ORGANIZATION_VIEW),
  syncsChannels(CHANNELS_LIST),
  connect(state => {
    const viewState = getViewState(state, ORGANIZATION_VIEW)
    return {
      isLoading: viewState && viewState.loading,
      isPristine: viewState && viewState.pristine,
    }
  })
)(LoadingOrChildren)
